import css from "./FeasibilitySummaryModal.module.css"; 
import { useState, useEffect } from "react";
import { ModalAction } from "../../Routes/NavRouter";
import Pictures from "../../Components/Form/Pictures/Pictures";

const FeasibilitySummaryModal = ({ children, onNext, survey, initial }) => {
    const { closeModal } = ModalAction;

    const [feasibilitySummary, setFeasibilitySummary] = useState("");
    const [uploadedPicture, setUploadedPicture] = useState(null);

    // Prefill state if editing existing report
    useEffect(() => {
        if (initial?.FeasibilitySummaryModal) {
            setFeasibilitySummary(initial.FeasibilitySummaryModal.feasibilitySummary || "");
            if (initial.FeasibilitySummaryModal.docId) {
                setUploadedPicture({
                    uploadId: initial.FeasibilitySummaryModal.docId,
                    value: null,
                    uploadType: "image/png",
                });
            }
        }
    }, [initial]);

    const handlePictureChange = (uploads) => {
        setUploadedPicture(uploads[0] || null);
    };

    const handleNext = () => {
        const reportData = {
            feasibilitySummary,
            docId: uploadedPicture?.uploadId || null,
        };
        children.FeasibilitySummaryModal = reportData;
        onNext && onNext(reportData);
    };

    return (
        <div className={css.Cont}>
            <div className={css.Body}>
                <div className={css.FormSection}>
                    <h3 className={css.SectionTitle}>Feasibility Summary</h3>
                    <textarea
                        className={css.TextArea}
                        placeholder="Is this site ready for installation? Highlight any red flags"
                        value={feasibilitySummary}
                        onChange={(e) => setFeasibilitySummary(e.target.value)}
                        rows={6}
                        required
                    />
                </div>

                <div className={css.FormSection}>
                    <h3 className={css.SectionTitle}>Upload Photo</h3>
                    <Pictures
                        load={uploadedPicture ? [uploadedPicture] : []}
                        onChange={handlePictureChange}
                        onDelete={() => setUploadedPicture(null)}
                    />
                </div>
            </div>

            <div className={css.ButtonsSection}>
                <button type="button" className={css.BtnSecondary} onClick={closeModal}>
                    Close
                </button>
                <button
                    type="button"
                    className={css.BtnPrimary}
                    onClick={handleNext}
                    disabled={!feasibilitySummary.trim()}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default FeasibilitySummaryModal;
